import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

/**
 * @template T
 * @param {T} object
 */
export default function useMemoObject(object) {
    const ref = useRef(object);

    if (!isEqual(ref.current, object)) {
        ref.current = object;
    }

    return ref.current;
}